import React, { useCallback } from 'react';
import webApp from '@happylife-a/web-app';
import webCore from '@happylife-a/web-core';
import { Box, Container, Grid, GridItem, Flex, Icon, Text, Divider } from '@chakra-ui/react';

import AccountMenu from '~components/Profile/AccountMenu';
import BookingCard from '~components/BookingCard';
import EmptyState from '~components/BookingCard/emptyState';

export default function BookingHistory() {
  const { t } = webCore.contexts.useTranslation();
  const screenSize = webApp.contexts.useScreenSize();

  const BREADCRUMBITEMS = [
    {
      label: t('Booking history'),
      link: '#',
    },
  ];

  const navigate = webApp.router.useNavigate();

  const onExplorePress = useCallback(() => {
    navigate('/');
  }, [navigate]);
  return (
    <Container maxW="7xl" mt={7} pb={24}>
      <Box>
        <webApp.components.Breadcrumb
          icon={<webApp.theme.icons.HomeIcon />}
          to="/"
          breadcrumbItems={BREADCRUMBITEMS}
        />
      </Box>

      {!screenSize.isMinTablet && (
        <>
          <Flex justifyContent="left" mt={6}>
            <webApp.components.LocalizedLink to="/account">
              <Icon as={webApp.theme.icons.BackIconV2} mt={1} />
            </webApp.components.LocalizedLink>

            <Text variant="sub-head-semi">{t('My profile')}</Text>
          </Flex>
          <Divider mt={4} />
        </>
      )}

      <Grid templateColumns="repeat(12, 1fr)" gap={5} mt={8}>
        {screenSize.isMinTablet && (
          <GridItem colSpan={2}>
            <AccountMenu />
          </GridItem>
        )}

        <GridItem
          colSpan={screenSize.isMinTablet ? 10 : 12}
          display="flex"
          flexDir="column"
          gap={4}
        >
          {bookings?.length > 0 ? (
            <>
              {bookings?.map((booking) => (
                <BookingCard key={booking.id} {...booking} />
              ))}
            </>
          ) : (
            <EmptyState onExplorePress={onExplorePress} />
          )}
        </GridItem>
      </Grid>
    </Container>
  );
}

const bookings = [];
